import { firestore, getP2AMessagesCollection } from '../common/lib/firebase'

export default (roomId: string, observer: (data: any) => void) => {
  return firestore
    .collection(getP2AMessagesCollection(roomId))
    .orderBy('createdAt')
    .onSnapshot((result: any) => {
      const data: any[] = []
      result.docs.forEach((x: any) => {
        data.push(x.data())
      })
      observer(data)
    })
}
